import axios from "axios";
import { toast } from "react-toastify";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import { API_BASE_PATH } from "../environment";

const BASE_URL = `${API_BASE_PATH}/notes`;

export interface Note {
    note_id: string;
    notes_decription: string;
    type: string;
}

const getAuthHeaders = () => {
    const token = localStorage.getItem("authToken") || "";
    return {
        Authorization: token,
        Accept: "application/json",
    };
};

const showAxiosError = (error: any, fallback: string) => {
    const detail = error?.response?.data?.detail || error?.message || fallback;
    toast.error(detail);
};

// Fetch notes by user ID
export const getNotesByUserId = async (userId: string): Promise<Note[]> => {
    try {
        if(!userId) return [];
        const response = await axios.get(`${BASE_URL}/${userId}`, {
            headers: getAuthHeaders(),
        });
        return response.data;
    } catch (error: any) {
        const status = error?.response?.status;

        // Suppress toast if it's 404 (no notes found)
        if (status !== 404) {
            console.error("API Error:", error);
            showAxiosError(error, "Failed to fetch notes");
        } else {
            console.warn("No notes found for this user.");
        }

        // Always return an empty array if notes not found (optional)
        if (status === 404) {
            return [];
        }

        throw error;
    }
};


// POST: Create a new note
export const createNote = async (
    notes_decription: string
): Promise<Note> => {
    try {
        const formData = new URLSearchParams();
        formData.append("notes_decription", notes_decription);

        const response = await axios.post<Note>(
            `${API_BASE_PATH}/create/`,
            formData,
            {
                headers: {
                    ...getAuthHeaders(),
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            }
        );
        toast.success("Note created Successfully")
        return response.data;
    } catch (error) {
        showAxiosError(error, "Failed to create note");
        throw error;
    }
};

// PUT: Update existing note by note_id

export const updateNote = async (
    note_id: string,
    notes_description: string
): Promise<Note> => {
    try {
        const formData = new URLSearchParams();
        formData.append("notes_description", notes_description);

        const response = await axios.put<Note>(
            `${API_BASE_PATH}/notes/${note_id}`,
            formData,
            {
                headers: {
                    ...getAuthHeaders(),
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            }
        );
        toast.success("Note updated Successfully")
        return response.data;
    } catch (error) {
        showAxiosError(error, `Failed to update note ${note_id}`);
        throw error;
    }
};

export const deleteNote = async (note_id: string): Promise<void> => {
    try {
        await axios.delete(`${BASE_URL}/${note_id}`, {
            headers: {
                ...getAuthHeaders(),
                Accept: "*/*",
            },
        });
    } catch (error) {
        showAxiosError(error, "Failed to delete note");
        throw error;
    }
};